module.exports = __webpack_public_path__ + "img/img9.952d3509.svg";